// extracted by mini-css-extract-plugin
export var boldText = "_6e-4";
export var checkboxContainer = "_6e-6";
export var closeIcon = "_6e-i";
export var container = "_6e-0";
export var drawer = "_6e-8";
export var drawerContent = "_6e-9";
export var extraSmallText = "_6e-5";
export var fulfillmentGroupTable = "_6e-e";
export var largeText = "_6e-3";
export var loadingSpinnerContainer = "_6e-j";
export var mediumText = "_6e-2";
export var narrow = "_6e-f";
export var notificationLink = "_6e-l";
export var packageCheckIconContainer = "_6e-7";
export var slideoutHeaderActions = "_6e-g";
export var slideoutHeaderActionsShifted = "_6e-h";
export var slideoutHeaderContainer = "_6e-a";
export var slideoutModal = "_6e-c";
export var stickyHeaderWrapper = "_6e-b";
export var table = "_6e-k";
export var tableContainer = "_6e-d";
export var tertiaryText = "_6e-1";